export function parseErrorMessages(messages: string[]): string {
  return messages.join(' ');
}
